import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import {PERIOD_TYPES} from 'config/constants/period';

import PeriodDropdownContainer from 'containers/period/PeriodDropdownContainer';

import {removeQueryParams, getQueryParams, setQueryParams} from 'util/router';
import {RADIX_DECIMAL} from 'util/constants';

export const QUERY_PARAM_PERIOD_TYPE = 'periodType';
export const QUERY_PARAM_PERIOD_MONTH = 'month';
export const QUERY_PARAM_PERIOD_DATE = 'date';

const HOURS = 12;
const MINUTES = 0;
const SECONDS = 0;

/* This container links the Period component with Redux */
export class PeriodDropdownRoute extends Component {

    static propTypes = {
        history:       PropTypes.object.isRequired, // The history route object
        section:       PropTypes.string.isRequired, // The section where the component is going to take the data
        dropdownItems: PropTypes.array, // The array with the items to show in the dropdown for types
        onChange:      PropTypes.func // Listener when the date has been selected
    };

    /**
     * Change the browser title and set this to handlers
     */
    componentWillMount() {
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(type, date) {
        const {onChange, history:{location: {search}}} = this.props;
        const query = getQueryParams(search);
        const oldType = query[QUERY_PARAM_PERIOD_TYPE];

        const myDate = new Date(date);

        myDate.setHours(HOURS);
        myDate.setMinutes(MINUTES);
        myDate.setSeconds(SECONDS);

        if (oldType !== type) {
            setQueryParams(this.props, QUERY_PARAM_PERIOD_TYPE, type);
        }

        if (myDate) {
            const _date = myDate instanceof Date ? myDate.getTime() : myDate;

            if (type === PERIOD_TYPES.PERIOD_TYPE_MONTH) {
                setQueryParams(this.props, QUERY_PARAM_PERIOD_MONTH, _date);
                removeQueryParams(this.props, QUERY_PARAM_PERIOD_DATE);
            } else if (type === PERIOD_TYPES.PERIOD_TYPE_DATE) {
                setQueryParams(this.props, QUERY_PARAM_PERIOD_DATE, _date);
                removeQueryParams(this.props, QUERY_PARAM_PERIOD_MONTH);
            }
        }


        onChange && onChange(type, myDate.getTime());
    }

    render() {
        const {section, dropdownItems, history:{location: {search}}} = this.props;
        const query = getQueryParams(search);
        const type = query[QUERY_PARAM_PERIOD_TYPE];
        let value;


        if (type === PERIOD_TYPES.PERIOD_TYPE_MONTH) {
            value = query[QUERY_PARAM_PERIOD_MONTH] && parseInt(query[QUERY_PARAM_PERIOD_MONTH], RADIX_DECIMAL);
        } else if (type === PERIOD_TYPES.PERIOD_TYPE_DATE) {
            value = query[QUERY_PARAM_PERIOD_DATE] && parseInt(query[QUERY_PARAM_PERIOD_DATE], RADIX_DECIMAL);
        }

        return (
            <PeriodDropdownContainer
                section={section}
                dropdownItems={dropdownItems}
                type={type}
                value={value}
                onChange={this.handleChange}
            />
        );
    }
}

export default withRouter(PeriodDropdownRoute);



// WEBPACK FOOTER //
// ./src/router-with/period/PeriodDropdownRoute.jsx